import React from "react";
import { Card, Tag, Space, Typography, Collapse, List, Avatar } from "antd";
import {
  EnvironmentOutlined,
  PhoneOutlined,
  MailOutlined,
} from "@ant-design/icons";
import config from "../../../api_config.json";
import ParseLogo from "../../shared/images/parse.png";

const { Text } = Typography;

const OfficeCard = ({ office, env }) => {
  const phones = [
    office.telefono1,
    office.telefono2,
    office.cellulare1,
    office.cellulare2,
  ].filter(Boolean);

  return (
    <Card className="office-card" size="small">
      {/* Header with Name and Status */}
      <div className="office-card-header">
        <div className="office-card-company">
          {office.name || office.citta || "Sede"}
        </div>
        <Space size={4}>
          <Tag
            color={office.enabled ? "green" : "red"}
            style={{ margin: 0 }}
          >
            {office.enabled ? "Attiva" : "Non Attiva"}
          </Tag>
          {office.nascondi && (
            <Tag color="orange" style={{ margin: 0 }}>
              Nascosta
            </Tag>
          )}
        </Space>
      </div>

      {/* Location Info */}
      <div className="office-card-location">
        <EnvironmentOutlined style={{ marginRight: 8, color: "#1890ff" }} />
        <div>
          <Text strong>
            {office.citta || "Senza citta"}
            {office.frazione && `, ${office.frazione}`}
            {office.provincia && ` (${office.provincia})`}
          </Text>
          <br />
          <Text type="secondary">
            {office.indirizzo || ""}
            {office.cap && ` - ${office.cap}`}
          </Text>
        </div>
      </div>

      {/* Contact Info */}
      {(phones.length > 0 || office.email || office.pec) && (
        <div className="office-card-contacts">
          {phones.length > 0 && (
            <div className="office-card-contact-row">
              <PhoneOutlined style={{ marginRight: 8, color: "#52c41a" }} />
              <Text>{phones.join(" / ")}</Text>
            </div>
          )}
          {office.email && (
            <div className="office-card-contact-row">
              <MailOutlined style={{ marginRight: 8, color: "#fa8c16" }} />
              <Text>{office.email}</Text>
            </div>
          )}
          {office.pec && (
            <div className="office-card-contact-row">
              <MailOutlined style={{ marginRight: 8, color: "#722ed1" }} />
              <Text style={{ fontSize: 12 }}>PEC: {office.pec}</Text>
            </div>
          )}
        </div>
      )}

      {/* Users Section */}
      {office.users && office.users.length > 0 && (
        <div className="office-card-users">
          <Collapse ghost size="small">
            <Collapse.Panel
              header={`${office.users.length} persone`}
              key="1"
            >
              <List
                size="small"
                itemLayout="horizontal"
                dataSource={office.users}
                renderItem={(user) => (
                  <List.Item style={{ padding: "8px 0" }}>
                    <List.Item.Meta
                      avatar={
                        user.profile_picture ? (
                          <Avatar
                            size="small"
                            src={user.profile_picture.url}
                          />
                        ) : (
                          <Avatar size="small">
                            {((user.first_name || "U")[0] || "").toUpperCase()}
                          </Avatar>
                        )
                      }
                      title={
                        <Text style={{ fontSize: 13 }}>
                          {user.first_name} {user.last_name}
                        </Text>
                      }
                      description={
                        <Text type="secondary" style={{ fontSize: 12 }}>
                          {user.email || user.telefono || ""}
                        </Text>
                      }
                    />
                  </List.Item>
                )}
              />
            </Collapse.Panel>
          </Collapse>
        </div>
      )}

      {/* Footer with ID and Links */}
      <div className="office-card-footer">
        <Text type="secondary" style={{ fontSize: 11 }}>
          ID: {office.objectId}
        </Text>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`${config.parseDashboard[env]}/browser/office?filters=[{"field":"objectId","constraint":"eq","compareTo":"${office.objectId}"}]`}
        >
          <img src={ParseLogo} width={18} alt="Parse" />
        </a>
      </div>
    </Card>
  );
};

export default OfficeCard;
